export class ConfirmationModal{ 
    
    headerMessage:string;
    bodyMessage:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/announcements/entities/confirmation-modal.ts